<template>
    <div class="row p-10">
        <Loader v-if="loadingRevision"/>
        <div class="col-sm-6 pt-3" v-else>
            {{primaryLanguage}}
            <div class="form-group" :class="{'rtl': primaryLanguage == 'ar'}" v-for="header in current_headers[primaryLanguage]" v-if="header.value != '' && header.value != null" >
                <label for="" class="text-bold" :class="{'rtl': primaryLanguage == 'ar'}"> {{formatHeaderName(header.header_name)}}</label>
                <div v-html="header.value + header.value_dropdown" ></div>
            </div>
        </div>
        <!-- <div v-for="language in languages" class="col-sm-6 pt-3" v-else>
            {{language}}
            <div class="form-group" v-for="header in current_headers[language]" v-if="header.value != '' && header.value != null" >
                <label for="" class="text-bold"> {{formatHeaderName(header.header_name)}}</label>
                <div v-html="header.value" ></div>
            </div>
        </div> -->

    </div>
</template>

<script>
import Editor from '@/components/common/Editor/Editor'
import Loader from '@/components/common/Loader'

export default {
  props: ['product', 'revision', 'primaryLanguage'],
  components: { Editor, Loader },
  data: function () {
    return {
      languages: [],
      loadingRevision: true,
      current_revision: '',
      current_headers: {}
    }
  },
  mounted: function () {
    this.getProductRevision()
  },
  methods: {
    getProductRevision: function () {
      var self = this

      const url = '/copydesk/product/revision'
      let data = {
        id_product: self.product.id_product || self.product.product.id_product,
        id_copy_revision: self.revision
      }

      self.loadingRevision = true
      this.$http.post(url, data, {
        dataType: 'json',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          self.current_revision = response.data.copy_revision.revision
          self.formatRevision()
          self.loadingRevision = false
        })
        .catch(function (error) {
          self.loadingRevision = false
          self.$store.dispatch('updateToast', { text: (error.response && error.response.data) || 'Something went wrong', show: true })
        })
    },
    formatHeaderName: function (name) {
      return name.toLowerCase()
        .split('_')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join('_')
        .replace(/_/g, ' ')
    },
    formatRevision: function () {
      var self = this

      let revision = JSON.parse(self.current_revision)
      self.languages = Object.keys(revision)

      const languageHeaders = {}

      self.languages.map(function (language) {
        languageHeaders[language] = revision[language].map(value => {
          if (value.value != '' || value.value != null) {
            return { header_name: value.header_name, value: value.value, value_dropdown: (value.value_dropdown ? value.value_dropdown : '') }
          }
        })
      })
      self.current_headers = languageHeaders
      // self.current_headers = revision.map(value => {

      //     if(value.value != '' || value.value != null) {
      //         return {header_name: value.header_name, value: value.value}
      //     }

      // })
    }
  }
}
</script>

<style>
.text-bold{
    font-weight: bold;
}
.rtl{
  direction: rtl;
    /* unicode-bidi: bidi-override !important;
    direction: unset !important; */
    text-align:right;
}
</style>
